<template>
  <VWidget
    css-class="draggable-item hover-border"
    content-class="px-1 py-1"
    :header-separator="false"
    :enable-content="expanded"
  >
    <template slot="title">{{ item.display }}</template>

    <template slot="header-actions">
      <option-menu no-confirm :item="item" :edit-item="goTo" :delete-item="onDelete" />
      <v-btn small icon @click="expanded = !expanded">
        <v-icon small v-text="$vuetify.icons.values.collapse" v-if="expanded" />
        <v-icon small v-text="$vuetify.icons.values.expand" v-else />
      </v-btn>
    </template>
    <template slot="content" v-if="expanded">
      <v-expand-transition>
        <v-list dense>
          <template v-for="transition in sorted">
            <v-divider :key="`${item.name}-${transition.name}-sep`" />
            <v-list-item :key="`${item.name}-${transition.name}`">
              <v-list-item-avatar>
                <v-icon small v-if="transition.ingress"> $vuetify.icons.values.ingress </v-icon>
                <v-icon small v-else>$vuetify.icons.values.egress</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-subtitle>
                  {{ transition.display }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-chip label small color="default" v-if="transition.ingress">
                  {{ $t('labels.ingress') }}
                </v-chip>
                <v-chip label small color="default" v-else>
                  {{ $t('labels.egress') }}
                </v-chip>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list>
      </v-expand-transition>
    </template>
  </VWidget>
</template>

<script>
import { orderBy } from 'lodash/collection'
import { mapState, mapActions } from 'vuex'
import { NAMESPACE } from '../store'
import { VWidget, OptionMenu } from '@argon/app/components'

export default {
  name: 'FlowStateListItem',
  components: {
    VWidget,
    OptionMenu
  },
  props: {
    item: { type: Object, required: true },
    flowId: {
      type: [String, Number],
      required: true
    },
    onDelete: { type: Function, required: true }
  },
  data: () => ({
    menu: false,
    expanded: false
  }),
  computed: {
    ...mapState(NAMESPACE, ['current']),
    transitions() {
      return this.current
        ? this.current.meta.transitions
            .filter((x) => x.to_state === this.item.name || x.from_state === this.item.name)
            .map((x) => ({ ...x, ingress: x.to_state === this.item.name }))
        : []
    },
    sorted() {
      return orderBy(this.transitions, ['ingress', 'display'], ['desc', 'asc'])
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['deleteState']),
    goTo(state) {
      let params = { ...this.$route.params, stateName: state.name }
      this.$router.push({ name: 'flowState', params })
    }
  }
}
</script>

<style scoped lang="scss">
.draggable-item {
  margin-bottom: 5px;
}
</style>
